import React from "react";
import Pageslide from "../../commanfile/Pageslide";
// import { GoogleMap } from "@react-google-maps/api";
import ApointmentForm from "../../commanfile/ApointmentForm";
import { IoIosCall } from "react-icons/io";
import { LuMail } from "react-icons/lu";
import { MdOutlineLocationOn } from "react-icons/md";
import {
  FaFacebookSquare,
  FaInstagramSquare,
  FaLinkedin,
  FaTwitterSquare,
} from "react-icons/fa";
import { GrYoutube } from "react-icons/gr";
import imagescontact from "../../Images/contactsusimages.jpeg";

const Contactus = () => {
  return (
    <>
      <div className="max-w-[1456px] mx-auto ">
        <div className="mx-auto">
          <Pageslide 
           className={"w-[100%] lg:h-[750px] pt-3  sm:w-[100%]"} 
           imgaes={imagescontact}
            />
        </div>
        <div className=" md:flex gap-3  items-center ">
          <div className="mx-auto px-1 ">
            <ApointmentForm />
          </div>
          <div className="mx-auto md:w-[50%] px-2">
            <p className="text-3xl font-roboto text-[#469B8F] font-bold pt-10">
              Contact Psynexa mind care Hospital
            </p>
            <p className="text-lg font-roboto pt-2">
            
              let's talk about mind problems
            </p>
            <p className="font-roboto text-xl w-auto pt-2">
              At Mind Care Hospital, we believe in guiding individuals on their
              unique
              <span className="font-semibold uppercase text-[#469B8F]">
                paths to happiness
              </span>
              through compassionate care, emotional healing,
              and personalized mental health support."
            </p>

            <div className=" ">
              <p className="py-3 font-roboto">Follow us:</p>
              <div className="flex gap-3 pt-3">
                <a href="https://www.instagram.com/psynexa_/">
                  <FaInstagramSquare className="text-3xl rounded-xl text-[#E4405F]" />
                </a>
                <a href="https://www.facebook.com/share/15G9kb7Wfb/?mibextid=wwXIfr">
                  <FaFacebookSquare className="text-3xl rounded-xl text-[#3B5998] " />
                </a>
                <a href="https://www.youtube.com/@dranantchangela">
                  <GrYoutube className="text-3xl rounded-xl text-[#FF0000]" />
                </a>
                <a href="https://www.linkedin.com/in/dr-anant-changela-9a5312363">
                  <FaLinkedin className="text-3xl rounded-xl text-[#0077B5]" />
                </a>
              </div>
            </div>
            <div className="">
              <p className="font-roboto pt-5 flex gap-3  lg:w-full  md:w-[80%] items-center text-[16px]">
                <MdOutlineLocationOn className=" text-[30px] " />
                419, Time Shoppers, Nr. Amiras Restaurant,
                <br /> B/s Millennium Business Hub, Sarthana Jakatnaka, <br />{" "}
                Surat, Gujarat - 395013
              </p>
              <p className="flex gap-3 pt-4 items-center text-[16px]">
                <LuMail className=" text-[25px]" />
                Dr.Anant@psynexa.in
              </p>
              <p className="pt-4  gap-3 flex items-center text-[16px] ">
                <IoIosCall className=" text-[25px]" /> +91 85758 88887
              </p>
            </div>
          </div>
        </div>
        <div className=""></div>
      </div>
    </>
  );
};

export default Contactus;
